import { render, staticRenderFns } from "./PrasymasAsmenys.vue?vue&type=template&id=52037756&scoped=true&"
import script from "./PrasymasAsmenys.vue?vue&type=script&lang=js&"
export * from "./PrasymasAsmenys.vue?vue&type=script&lang=js&"
import style0 from "./PrasymasAsmenys.vue?vue&type=style&index=0&id=52037756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52037756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VContainer,VDataTable,VRow,VSpacer,VToolbar})
